export function stringifyArray(array) {
    const makeStrings = array.map((item) => item.toString())
    return makeStrings
}
